export default __webpack_public_path__ + "static/media/what-is-neo-fest.708ab9d7.png";